import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuxiliaresModule } from '../../../auxiliares/auxiliares.module';
import { FacturacionComponent } from './facturacion.component';
import { CrearEditarFacturacionComponent } from './crear-editar-facturacion/crear-editar-facturacion.component';
import { CrearResumenComponent } from './crear-resumen/crear-resumen.component';
import { FacturacionRoutingModule } from './routing';

@NgModule({
  declarations: [
    FacturacionComponent,
    CrearEditarFacturacionComponent,
    CrearResumenComponent,
  ],
  imports: [CommonModule, AuxiliaresModule, FacturacionRoutingModule],
  exports: [FacturacionComponent],
})
export class FacturacionModule {}
